import { render, staticRenderFns } from "./AdminEditAboutUs.vue?vue&type=template&id=e1497510&scoped=true&"
import script from "./AdminEditAboutUs.vue?vue&type=script&lang=ts&"
export * from "./AdminEditAboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./AdminEditAboutUs.vue?vue&type=style&index=0&id=e1497510&scoped=true&lang=css&"
import style1 from "./AdminEditAboutUs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1497510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
